import { createContext } from 'react';

const UserContext = createContext(null);

const SubsContext = createContext(null);

const ThemeContext = createContext(null);

export { UserContext, SubsContext, ThemeContext };